import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import * as React from 'react';
import { SponsorListing } from './sponsor-listing';
import './sponsor.css';

export class Sponsor extends React.Component {
  public render() {
    const primarySponsors = [
      {
        link: 'http://www.drpeppersnapplegroup.com/',
        primary: 'Dr. Pepper Snapple Group',
        secondary: 'drpeppersnapplegroup.com'
      },
      {
        primary: 'Knights of Columbus',
        secondary: 'Council 11354'
      },
      {
        link: 'http://www.pagetechltd.com/',
        primary: 'pagetech limited',
        secondary: 'pagetechltd.com',
      },
      {
        link: 'http://www.superiorbeveragegroup.com/',
        primary: 'Superior Beverage Group',
        secondary: 'superiorbeveragegroup.com',
      },
      {
        link: 'http://www.ttmurphs.com/',
        primary: 'T.T. Murph\'s',
        secondary: 'ttmurphs.com',
      },
    ];

    const cornerstoneSponsors = [
      {
        link: 'http://www.corna.com/',
        primary: 'Corna Kokosing Construction Company',
        secondary: 'corna.com'
      },
      {
        link: 'http://jonesschlaterflooring.com/',
        primary: 'Jones Schlater Flooring',
        secondary: 'jonesschlaterflooring.com',
      },
      {
        link: 'https://www.martinpainting.com/',
        primary: 'Martin Painting &amp; Coating',
        secondary: 'martinpainting.com',
      },
      {
        link: 'http://www.granvillebuilderssupply.com/',
        primary: 'Granville Builder\'s Supply',
        secondary: 'granvillebuilderssupply.com',
      },
      {
        link: 'http://www.laforceinc.com/',
        primary: 'LaForce Inc.',
        secondary: 'laforceinc.com',
      },
      {
        primary: 'McClintock Electric',
      },
      {
        link: 'http://www.muetzel.com/',
        primary: 'Muetzel Plumbing Heating Cooling',
        secondary: 'muetzel.com',
      },
      {
        link: 'http://www.d8fire.com//',
        primary: 'Double Eight Fire Protection',
        secondary: 'd8fire.com',
      },
    ];

    const goldSponsors = [
      {
        link: 'http://www.columbussign.com/',
        primary: 'Columbus Sign Company',
        secondary: 'columbussign.com'
      },
      {
        link: 'http://www.designcanbedangerous.com/',
        primary: 'Creative Design Solutions',
        secondary: 'designcanbedangerous.com'
      },
      {
        link: 'http://www.egan-ryan.com/',
        primary: 'Eagan-Ryan Funeral Services',
        secondary: 'egan-ryan.com'
      },
      {
        link: 'http://www.happychickenfarms.com/',
        primary: 'Creative Design Solutions',
        secondary: 'happychickenfarms.com'
      },
      {
        link: 'http://www.hmbnet.com/',
        primary: 'Happy Chicken Farms/Merry Milk Maid',
        secondary: 'hmbnet.com'
      },
      {
        primary: 'Post Electrical Services'
      },
      {
        primary: 'Bill and Sheila Riat'
      },
    ];

    const blueSponsors = [
      {
        link: 'http://www.ahni.com/',
        primary: 'America Health Network Grant Bexley Family Practice',
        secondary: 'ahni.com'
      },
      {
        link: 'https://www.facebook.com/BEER-DOCK-EAST-35234283246/',
        primary: 'Beer Dock East',
        secondary: 'Follow us on Facebook'
      },
      {
        link: 'http://www.columbuscoal.com/',
        primary: 'Columbus Coal &amp; Lime Company',
        secondary: 'columbuscoal.com'
      },
      {
        primary: 'The DeWitt Familty',
      },
      {
        link: 'http://www.fortnerinc.com/',
        primary: 'Fortner Upholstering Inc',
        secondary: 'fortnerinc.com'
      },
      {
        primary: 'Mitch and Kathy Fries',
      },
      {
        link: 'http://www.jbhamlin.com/',
        primary: 'JBHamlin &amp; Company',
        secondary: 'jbhamlin.com'
      },
      {
        primary: 'The Heil Family',
      },
      {
        link: 'https://www.jerseymikes.com/2060/columbus-oh',
        primary: 'Jersey Mike\'s Subs',
        secondary: 'jerseymikes.com'
      },
      {
        primary: 'Krajnak Birdhouse Studio',
      },
      {
        primary: 'Mosiac Community Health Care Center',
      },
      {
        primary: 'The Michael Murphy Family',
      },
      {
        link: 'http://www.plankscafe.com/',
        primary: 'Plank\'s Cafe',
        secondary: 'plankscafe.com'
      },
      {
        link: 'http://recasafinancial.com/',
        primary: 'ReCasa Financial Group The Quinlan Family',
        secondary: 'recasafinancial.com'
      },
      {
        primary: 'Jerome R. Schindler Attorney at Law',
      },
      {
        primary: 'The Vautour Family',
      },
    ];

    const greenSponsors = [
      {
        primary: 'George and Vanessa Arnold',
      },
      {
        link: 'http://www.grain-grape.net/',
        primary: 'Grain + Grape',
        secondary: 'grain-grape.net'
      },
      {
        link: 'http://www.grain-grape.net/',
        primary: 'Grain + Grape',
        secondary: 'grain-grape.net'
      },
      {
        primary: 'Steve and Rita Hoyt',
      },
      {
        link: 'https://hrabowybraces.com/',
        primary: 'Eric Hrabowy, DDS, MS, Inc',
        secondary: 'hrabowybraces.com'
      },
      {
        link: 'https://www.maederquinttiberi.com/',
        primary: 'Maeder-Quint-Tiberi Funeral Home',
        secondary: 'maederquinttiberi.com'
      },
      {
        link: 'https://www.marcy.com/',
        primary: 'Marcy Design Group',
        secondary: 'marcy.com'
      },
      {
        link: 'https://www.drchristophermasoner.com/',
        primary: 'Christopher D. Masoner, DDS',
        secondary: 'drchristophermasoner.com'
      },
      {
        link: 'http://www.murraystool.com/',
        primary: 'Murrays Tool Rental',
        secondary: 'murraystool.com'
      },
      {
        primary: 'Mary &amp; AJ Myers &amp; Family',
      },
      {
        link: 'http://www.myerssurveying.com/',
        primary: 'Myers Surveying, Inc',
        secondary: 'myerssurveying.com'
      },
      {
        link: 'http://www.olrblaw.com/',
        primary: 'Odna, LaBugn, Rankin &amp; Boggs, LPA',
        secondary: 'olrblaw.com'
      },
      {
        link: 'http://www.primeequipmentgroup.com/',
        primary: 'Prime Equipment Group, Inc',
        secondary: 'primeequipmentgroup.com'
      },
      {
        link: 'http://www.ryanbrotherslandscaping.com',
        primary: 'Ryan Brothers\' Landscaping',
        secondary: 'ryanbrotherslandscaping.com'
      },
      {
        link: 'http://wingsofbexley.com/',
        primary: 'Wings Restaurant',
        secondary: 'wingsofbexley.com'
      },
    ];

    const benchSponsors = [
      {
        primary: 'Burkhardt and Badurina Families Pray the Rosary',
      },
      {
        primary: 'Dr. Anthony Dinapoli and Associates Family Dentistry (614) 231-6872',
      },
      {
        primary: 'Relax! Curtesy of the Griffith Family',
      },
      {
        primary: 'In Honor of The James D. Murphy Family',
      },
      {
        primary: 'The Page Families Phil &amp; Karen John &amp; Nancy',
      },
      {
        primary: 'In Honor of Saint Catherine Parish Priests',
      },
      {
        primary: 'Rubinos Pizzeria',
      },
      {
        primary: 'In Honor of Monsignor James L.T. Ruef',
      },
      {
        primary: 'The Sybert Family',
      },
    ];

    const webSponsors = [
      {
        primary: 'Knect Creative',
      },
      {
        primary: 'Mosiac Community Healthcare Center',
      },
      {
        link: 'http://www.wirthmanauto.com/',
        primary: 'Wirthman Brothers',
        secondary: 'wirthmanauto.com'
      },
    ];

    return (
      <div className="sponsor">
        <ListItem className="presenting-header">
          <ListItemText primary="Presenting Sponsors" />
        </ListItem>
        <Collapse in={true} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            {primarySponsors.map((listing, idx) => (<SponsorListing key={idx} listing={listing} />))}
          </List>
        </Collapse>
        <ListItem className="cornerstone-header">
          <ListItemText primary="Cornerstone Sponsors" />
        </ListItem>
        <Collapse in={true} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            {cornerstoneSponsors.map((listing, idx) => (<SponsorListing key={idx} listing={listing} />))}
          </List>
        </Collapse>
        <ListItem className="gold-header">
          <ListItemText primary="Gold Level Sponsors" />
        </ListItem>
        <Collapse in={true} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            {goldSponsors.map((listing, idx) => (<SponsorListing key={idx} listing={listing} />))}
          </List>
        </Collapse>
        <ListItem className="blue-header">
          <ListItemText primary="Blue Level Sponsors" />
        </ListItem>
        <Collapse in={true} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            {blueSponsors.map((listing, idx) => (<SponsorListing key={idx} listing={listing} />))}
          </List>
        </Collapse>
        <ListItem className="green-header">
          <ListItemText primary="Blue Level Sponsors" />
        </ListItem>
        <Collapse in={true} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            {greenSponsors.map((listing, idx) => (<SponsorListing key={idx} listing={listing} />))}
          </List>
        </Collapse>
        <ListItem className="bench-header">
          <ListItemText primary="Blue Level Sponsors" />
        </ListItem>
        <Collapse in={true} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            {benchSponsors.map((listing, idx) => (<SponsorListing key={idx} listing={listing} />))}
          </List>
        </Collapse>
        <ListItem className="web-header">
          <ListItemText primary="Web Sponsors" />
        </ListItem>
        <Collapse in={true} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            {webSponsors.map((listing, idx) => (<SponsorListing key={idx} listing={listing} />))}
          </List>
        </Collapse>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sponsor/index.tsx